module.exports = __webpack_public_path__ + "nunito-sans-latin-600italic.0de4a8bace81fc8b1f570af06a28e385.woff2";